import { Box, Button, Container, Grid, Paper, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { AppContext } from '@/utils/appContext';
import { makeStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/Close';
import CartTimeAlert from './CartTimeAlert';
import Cart from './Cart';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import EmptyCartContainer from "./EmptyCartContainer";
import {useCountdownDate} from '@/hooks/use-countdown';
import {g, gEventViewCart, website} from '@/utils/helpers';

const DrawerCart = () => {
  const appContext = useContext(AppContext);
  const { classes } = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {distance} = useCountdownDate(appContext.cartExpireAt ?? new Date())

  const goToCustomerDetails = () => {
    navigate(`/booking`);
    appContext.setDrawerCart(false);
  };

  useEffect(() => {
    const p = appContext.properties.find(p => p.code === appContext.propertySelected);
    if (!p) return;
    g('event', 'view_cart_v2', gEventViewCart(appContext, p));
  }, []);

  return (
    <Container maxWidth={'lg'} sx={{ padding: { xs: '0px 0px 50px!important', sm: '20px 50px!important'}, paddingBottom: {xs: '125px!important' , sm: '150px!important' } }}>
      <Box className={classes.cartHeader} mb={3} pb={2}>
        <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ position: 'relative' }}>
          <Grid item xs={1} className={classes.backBtn}>
            <CloseIcon
              fontSize={'small'}
              onClick={() => {
                appContext.setDrawerCart(!appContext.drawerCart);
              }}
            />
          </Grid>
          <Grid item xs={12} textAlign={'center'}>
            <Typography variant={'h4'} component={'h4'}>
              {t('Your_cart')} ({appContext.cart.length})
            </Typography>
          </Grid>
        </Grid>
        {distance > 0 && <CartTimeAlert />}
      </Box>
      {appContext.cart.length > 0 ? (
        <>
          <Box>
            <Cart origin='DrawerCart' />
          </Box>
          <Paper elevation={2} square className={classes.confirmBtn}>
            <Box>
              {website.code !== 'VP' && website.properties.length !== 1 ? (
                <Button color="primary" variant="contained" className={'buttonRoot'} onClick={() => goToCustomerDetails()}>
                  {t('complete_order')}
                </Button>
              ) : (
                <Button variant="contained" color="secondary" fullWidth onClick={() => goToCustomerDetails()}>
                  {t('complete_order')}
                </Button>
              )}
            </Box>
          </Paper>
        </>
      ) : (
        <EmptyCartContainer />
      )}
    </Container>
  );
};

export default DrawerCart;

const useStyles = makeStyles()((theme) => {
  return {
    backBtn: {
      cursor: 'pointer',
      position: 'absolute',
      '& p': {
        display: 'flex',
        alignItems: 'center',
        fontSize: 16,
        '& svg': {
          paddingRight: 10
        }
      }
    },
    cartHeader: {
      position: 'sticky',
      top: '-40px',
      backgroundColor: '#f2f2f2',
      paddingTop: 30,
      zIndex: 9
    },
    confirmBtn: {
      position: 'fixed',
      zIndex: 2,
      bottom: 0,
      right: 0,
      boxShadow: '0 -3px 10px #00000029',
      fontFamily: theme.typography.h6.fontFamily,
      fontSize: 24,
      width: 570,
      [theme.breakpoints.down('sm')]: {
        maxWidth: '-webkit-fill-available',
        padding: '20px 0!important'
      },
      '.MuiBox-root': {
        padding: '20px 50px',
        [theme.breakpoints.down('sm')]: {
          padding: '0 32px',
        }
      },
      '.buttonRoot': {
        width: '100%',
        backgroundColor: 'black',
        color: 'white',
        borderRadius: theme.radius.formBorderRadius,
        fontSize: 20,
        borderColor: 'black',
        '&:hover': {
          backgroundColor: 'black',
          color: 'white',
          borderColor: 'black'
        }
      }
    }
  };
});
